import { BlockType } from '@next-space/fe-api-idl';
import { cache } from 'src/redux/store';

/** 弹出菜单里有 input / textarea 元素时不触发全局的粘贴逻辑 */
export const check = () => {
  // 脑图节点选中状态下会有一个隐藏的textarea在focus状态，下面是为了监听是这种情况
  let isMindNodeHiddenTextareaFocused = false;
  if (document.activeElement instanceof HTMLElement) {
    isMindNodeHiddenTextareaFocused = !!document.activeElement.closest('.hidden-textarea');
  }
  if (isMindNodeHiddenTextareaFocused) return false;
  return (
    document.querySelector('#dropDownContent')?.querySelector('input') ||
    document.querySelector('#dropDownContent')?.querySelector('textarea') ||
    document.querySelector('[data-modal-id="SETTING"]') ||
    document.activeElement?.tagName === 'INPUT' ||
    document.activeElement?.tagName === 'TEXTAREA'
  );
};

export const isTableRow = () => {
  const { selectedCells } = cache.ui;
  if (selectedCells.length) {
    const { recordId, propertyId } = selectedCells[0] ?? {};
    if (recordId && propertyId) {
      const block = cache.blocks[recordId];
      return block?.type === BlockType.TABLE_ROW;
    }
  }
};
